export enum LogEventEntitiesEnum {
  File = "File",
  User = "User",
}
